import apiClient from 'utilities/apiClient';

export const document = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.document}/${url}`, payload, true);
};

export const create_batch = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.batch}/${url}`, payload, true);
};

export const create_weighment = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.weighing}/${url}`, payload, true);
};
